"use strict";
var Observable_1 = require('../../Observable');
var repeat_1 = require('../../operator/repeat');
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/rxjs/add/operator/repeat.js
// module id = ../../../../rxjs/add/operator/repeat.js
// module chunks = 3